/* eslint-disable */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DataTable from "../DataTable/DataTable";
import { getSubscribedCommunitiesList, getStatisticsSuccess } from "../../../actions";
import { history } from "../../../config/stores";
import Header from "../../Header/Header";
import "./FreeCommunities.scss";

const FreeCommunities = ({ getSubscribedCommunitiesList, getStatisticsSuccess, freeCommunities }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Set loading state and fetch free communities
    getStatisticsSuccess({ type: "freeCommunities", loading: true });
    setIsLoading(true);
    
    getSubscribedCommunitiesList({
      type: "free",
      name: "",
      participantsFrom: null,
      participantsTo: null,
      page: 1,
      limit: 20,
      onSuccess: () => setIsLoading(false),
      onError: () => setIsLoading(false)
    });
  }, []);

  const handleLoadMore = () => {
    if (freeCommunities?.hasNextPage && !isLoading) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      setIsLoading(true);
      
      getSubscribedCommunitiesList({
        type: "free",
        name: "",
        participantsFrom: null,
        participantsTo: null,
        page: nextPage,
        limit: 20,
        onSuccess: () => setIsLoading(false),
        onError: () => setIsLoading(false)
      });
    }
  };

  const handleBackToDashboard = () => {
    history.push('/');
  };

  return (
    <>
      <Header />
      <div className="main-container">
        <div className="inner-header-container">
          <div className="left-part">
            <div 
              className="close-icon" 
              onClick={handleBackToDashboard}
              title="Back to Dashboard"
            />
            <div className="inner-title">FREE COMMUNITIES</div>
          </div>
        </div>
        <div className="body-container">
          <DataTable
            data={freeCommunities || { docs: [] }}
            preset="freeCommunities"
            isLoading={freeCommunities?.loading || isLoading}
            onLoadMore={handleLoadMore}
            hasMore={freeCommunities?.hasNextPage}
            emptyStateText="No free communities found"
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  freeCommunities: state.dashboard.freeCommunities,
});

const mapDispatchToProps = (dispatch) => ({
  getSubscribedCommunitiesList: (payload) => dispatch(getSubscribedCommunitiesList(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FreeCommunities);
